'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Dashboard = _interopRequireDefault(require("Components/Lists/Dashboard"));
var _User = _interopRequireDefault(require("Components/Lists/Rows/User"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const header = [{
  name: 'login',
  label: 'E-mail'
}, {
  name: 'firstname',
  label: 'Nom'
}, {
  name: 'lastname',
  label: 'Prénom'
}, {
  name: 'phone',
  label: 'Téléphone'
}, {
  name: 'activity',
  label: 'Activité'
}];
const fields = header.map(infos => infos.name);

// Non-research like client picker, select, date picker, etc
const fields_without_timeout = [];
class UsersDashboardPage extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {});
    (0, _defineProperty2.default)(this, "handleSearchChange", _ref => {
      let {
        e,
        value,
        name
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;

      // Prevent on mount trigger
      if (!e && fields_without_timeout.includes(name) === false) return;
      component.setState({
        [name]: value
      });
      if (fields_without_timeout.includes(name)) return;
      if (component.search_timeout) {
        window.clearTimeout(component.search_timeout);
      }
      component.search_timeout = window.setTimeout(function () {
        component.search_timeout = undefined;
        component.setState({
          ['delayed_' + name]: value
        });
      }, 320);
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let filters = {
      searched: state.delayed_searched
    };
    let output = /*#__PURE__*/_react.default.createElement(_Back.default, (0, _extends2.default)({
      page_title: "Utilisateurs"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-right"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: (0, _Routing.URL)('NewUser'),
      className: (0, _bemit.default)('c-flat-btn', ['primary'])
    }, "Cr\xE9er un utilisateur")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      placeholder: " Recherche (e-mail)",
      value: state['searched'],
      name: "searched",
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-paper u-padding-top-0 no-horizontal-padding"
    }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
      model: "User",
      url: (0, _Routing.action)('getAllUsers'),
      header: header,
      fields: fields,
      component: _User.default,
      "items-per-page": 30,
      filters: filters
    })))));
    return output;
  }
}
exports.default = UsersDashboardPage;
